<template>
	<div class="adlib-page">
		<!-- Top bar -->
		<div class="adlib-topbar">
			<div class="adlib-left">
				<button v-hasPerm="['advert:library:insert']" class="adlib-upload-btn" @click="handlerInsert">
					<i class="el-icon-upload2"></i> {{ $t("adverts.AdLibrary.add") }}
				</button>
			</div>
			<div class="adlib-right">
				<input v-model="search.name" class="adlib-search" type="text"
					:placeholder="$t('adverts.AdLibrary.name')" @keyup.enter="onSubmit" />
				<button class="adlib-search-btn" @click="onSubmit"><i class="el-icon-search"></i> {{ $t("common.search") }}</button>
				<button class="adlib-reset-btn" @click="resetSearch">↻ {{ $t("common.reset") }}</button>
			</div>
		</div>

		<!-- Card grid -->
		<div v-loading="loading" class="media-grid-wrapper">
			<div class="media-grid">
				<div v-for="item in tableList" :key="item.id" class="media-card">
					<div class="card-image">
						<video v-if="item.type === 1" :src="item.url" class="card-video" muted></video>
						<img v-else :src="item.url" :alt="item.name" @error="handleImageError" />
						<button class="card-download-icon" :title="$t('adverts.AdLibrary.download')" @click.stop="download(item)">
							<i class="el-icon-download"></i>
						</button>
						<span class="card-tag" :class="item.display === 2 ? 'tag-banner' : 'tag-screen'">
							<i :class="item.display === 2 ? 'el-icon-picture' : 'el-icon-monitor'"></i>
							{{ item.display === 2 ? $t("adverts.AdLibrary.banner") : $t("adverts.AdLibrary.screen") }}
						</span>
					</div>
					<div class="card-content">
						<h3 class="card-title">{{ item.name }}</h3>
						<p class="card-desc">{{ item.advertiser }}</p>
						<div class="card-actions">
							<button class="cbtn cbtn-select" :disabled="selecting === item.id" @click="selectAd(item)">
								<i class="el-icon-plus"></i> {{ $t("adverts.AdLibrary.select") }}
							</button>
							<button v-if="item.uId == uId || pId == 0" v-hasPerm="['advert:library:update']"
								class="cbtn cbtn-edit" @click="handlerEdit(item)">
								<i class="el-icon-edit"></i>
							</button>
							<button v-if="item.uId == uId || pId == 0" v-hasPerm="['advert:library:delete']"
								class="cbtn cbtn-del" @click="delAd(item)">
								<i class="el-icon-delete"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div v-if="!loading && tableList.length === 0" class="adlib-empty">{{ $t("common.noData") }}</div>
			<el-pagination
				v-if="page.totalSize > page.pageSize"
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
				style="margin-top: 20px; text-align: center"></el-pagination>
		</div>

		<!-- Add / Edit dialog -->
		<add-ad-library :dialog="dialogAd" :adLib="adLib" :isEdit="isEdit" v-on:cancel="cancel"></add-ad-library>
	</div>
</template>

<script>
import addAdLibrary from "_c/adverts/AddAdLibrary";

export default {
	name: "AdLibrary",
	components: { addAdLibrary },
	data() {
		return {
			search: {},
			loading: false,
			tableList: [],
			page: { pageSize: 12, pageIndex: 1, totalSize: 0 },
			dialogAd: false,
			isEdit: false,
			adLib: {},
			pId: -1,
			uId: -1,
			selecting: null,
		};
	},
	mounted() {
		this.pId = localStorage.getItem("pId") || -1;
		this.uId = localStorage.getItem("uId") || -1;
		this.currentChange();
	},
	methods: {
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.AdLibrary.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.tableList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => (this.loading = false));
		},
		onSubmit() { this.currentChange(); },
		resetSearch() {
			Object.keys(this.search).map(key => (this.search[key] = null));
			this.currentChange();
		},
		handlerInsert() { this.isEdit = false; this.adLib = {}; this.dialogAd = true; },
		handlerEdit(row) { this.isEdit = true; this.adLib = Object.assign({}, row); this.dialogAd = true; },
		cancel(dialog, refresh) { this.dialogAd = dialog; if (refresh) this.currentChange(); },
		delAd(row) {
			this.$confirm(this.$t("adverts.AdLibrary.confirmDelete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api.request(this.$url.AdLibrary.delete, this.$method.delete, { id: row.id }).then(res => {
					if (res.code === 0) {
						this.$notify({ title: this.$t("common.tip"), message: res.msg, type: "success" });
						this.currentChange();
					} else this.$message.error(res.msg);
				});
			});
		},
		// Select: copy this master-library ad into the user's own ad library (ad gallery),
		// skipping if the same media already exists in their gallery.
		selectAd(row) {
			this.selecting = row.id;
			this.$api
				.request(this.$url.Adverts.listAdvertByGroupId, this.$method.get)
				.then(res => {
					const ads = (res && res.data) || [];
					const already = ads.some(a => a.url && row.url && a.url === row.url);
					if (already) {
						this.selecting = null;
						this.$message.warning(this.$t("adverts.AdLibrary.alreadyInGallery"));
						return;
					}
					const ad = {
						name: row.name,
						head: row.head || row.name,
						type: row.type,
						display: row.display || 1,
						url: row.url,
						thum: row.thum,
						advertiser: row.advertiser,
						price: row.price,
						len: row.len,
						adType: 0,
					};
					this.$api
						.request(this.$url.Adverts.insert, this.$method.post, ad)
						.then(r => {
							this.selecting = null;
							if (r.code === 0) {
								this.$notify({ title: this.$t("common.tip"), message: this.$t("adverts.AdLibrary.addedToLibrary"), type: "success" });
							} else {
								this.$message.error(r.msg);
							}
						})
						.catch(err => { this.selecting = null; this.$message.error(err && err.msg ? err.msg : ""); });
				})
				.catch(err => { this.selecting = null; this.$message.error(err && err.msg ? err.msg : ""); });
		},
		download(row) {
			if (!row.url) return;
			const a = document.createElement("a");
			a.href = row.url; a.download = row.name || "advertisement"; a.target = "_blank";
			document.body.appendChild(a); a.click(); document.body.removeChild(a);
		},
		handleImageError(e) { e.target.style.opacity = 0.3; },
	},
};
</script>

<style scoped>
.adlib-page { padding: 16px; }
.adlib-topbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 12px; }
.adlib-upload-btn { background: var(--vtm-mint); color: var(--vtm-navy); border: none; border-radius: 8px; padding: 9px 18px; font-size: 14px; font-weight: 600; cursor: pointer; }
.adlib-upload-btn:hover { background: var(--vtm-mint-dim); }
.adlib-right { display: flex; align-items: center; gap: 8px; }
.adlib-search { padding: 8px 12px; border: 1px solid var(--vtm-line-2); border-radius: 8px; background: var(--vtm-surface); color: var(--vtm-ink); font-size: 14px; outline: none; }
.adlib-search-btn, .adlib-reset-btn { padding: 8px 14px; border: 1px solid var(--vtm-line-2); border-radius: 8px; background: var(--vtm-surface); color: var(--vtm-ink); cursor: pointer; font-size: 14px; }
.adlib-search-btn { background: var(--vtm-mint); color: var(--vtm-navy); border-color: var(--vtm-mint); }
.media-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 20px; }
.media-card { background: var(--vtm-surface); border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border: 1px solid var(--vtm-line); transition: all 0.25s; }
.media-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.12); transform: translateY(-2px); }
.card-image { width: 100%; height: 200px; background: var(--vtm-well); position: relative; overflow: hidden; }
.card-image img, .card-video { width: 100%; height: 100%; object-fit: cover; }
.card-download-icon { position: absolute; top: 10px; left: 10px; width: 34px; height: 34px; border-radius: 8px; border: none; background: rgba(255,255,255,0.9); color: #1a1a1a; font-size: 17px; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 4px rgba(0,0,0,0.15); transition: all 0.15s; }
.card-download-icon:hover { background: #fff; color: var(--vtm-mint-dim); }
.card-tag { position: absolute; top: 10px; right: 10px; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; color: #fff; }
.card-tag.tag-screen { background: var(--vtm-mint); color: var(--vtm-navy); }
.card-tag.tag-banner { background: #8b5cf6; }
.card-content { padding: 14px; }
.card-title { margin: 0; font-size: 16px; font-weight: 700; color: var(--vtm-heading); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.card-desc { margin: 4px 0 12px; font-size: 13px; color: var(--vtm-ink-2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.card-actions { display: flex; gap: 8px; }
.cbtn { border: 1px solid var(--vtm-line-2); background: var(--vtm-surface); border-radius: 6px; padding: 6px 10px; font-size: 13px; cursor: pointer; color: var(--vtm-ink); }
.cbtn-select { background: var(--vtm-mint); color: var(--vtm-navy); border-color: var(--vtm-mint); flex: 1; font-weight: 600; }
.cbtn-select:disabled { opacity: 0.6; }
.cbtn-download { flex: 1; }
.cbtn:hover { opacity: 0.9; }
.cbtn-del:hover { color: var(--vtm-crit); border-color: var(--vtm-crit); }
.adlib-empty { text-align: center; color: var(--vtm-ink-3); padding: 60px 0; }
</style>
